import Icon from '../../../components/AppIcon';
import { CONTACT } from 'config/contact';

interface ContactHeroProps {
  onBookAudit: () => void;
}

const ContactHero = ({ onBookAudit }: ContactHeroProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-16 lg:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Sparkles" size={16} />
            <span>Free Automation Audit - No Commitment Required</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-primary mb-6">
            Let's Automate Your
            <span className="block text-primary mt-2">Business Success</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-text-secondary mb-8 leading-relaxed">
            Book a free 30-minute automation audit and discover how to reclaim 40-70 hours monthly. No sales pressure, just strategic insights tailored to your business.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={onBookAudit}
              className="inline-flex items-center space-x-2 bg-primary text-primary-foreground px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary/90 transition-colors duration-fast shadow-lg hover:shadow-xl"
            >
              <Icon name="Calendar" size={20} />
              <span>Book Free Audit</span>
            </button>
            
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-success text-success-foreground px-8 py-4 rounded-lg font-semibold text-lg hover:bg-success/90 transition-colors duration-fast"
            >
              <Icon name="MessageCircle" size={20} />
              <span>Chat on WhatsApp</span>
            </a>
          </div>
          
          <div className="flex items-center justify-center space-x-8 mt-12 text-sm text-text-secondary">
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} className="text-primary" />
              <span>Response within 2 hours</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} className="text-primary" />
              <span>100% Confidential</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircle" size={16} className="text-primary" />
              <span>No Obligation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;